import Hashids from 'hashids'

const hashing = new Hashids('', 6, '0123456789abcdefghijklmnopqrstuvwxyz')

export function hashIds(id) {
    return hashing.encode(id)
}
export function hashHex(id) {
    return hashing.encodeHex(id)
}
export function unhashIds(id) {
    return hashing.decode(id)
}
export function unhashHex(id) {
    return hashing.decodeHex(id)
}
